import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchManyInputModule } from '../../base/fc-search-many-input/fc-search-many-input.module';
import { FcPendencyTypesInputComponent } from './fc-pendency-types-input.component';

@NgModule({
  declarations: [
    FcPendencyTypesInputComponent
  ],
  imports: [
    FcSearchManyInputModule,
    TranslateModule
  ],
  exports: [
    FcPendencyTypesInputComponent
  ]
})
export class FcPendencyTypesInputModule {}
